import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { isNullOrEmpty } from '../helpers/LanguageHelpers';
import helpIcon from '../content/Help-16.png';

import './BootstrapHelpers.css';

function FieldGroup({ id, type, label, help, ...props }) {
    let cId = "c_" + id;
    return (
        <FormGroup controlId={cId}>
            <FormLabel>{label}</FormLabel>
            <Form.Control id={id} type={type} {...props} />
            {help && <span>{help}</span>}
        </FormGroup>
    );
}

export { FieldGroup };

export class Alert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: props.show
        }
    }

    hideAlert() {
        this.setState({
            show: null,
        });
        this.props.hideAlertHandler();
    }

    componentWillReceiveProps = (nextProps) => {
        // The constructor doesn't always get called because of React optimizations.  However, this will
        this.setState({ show: nextProps.show });
    }

    render() {
        let variant = "alert-" + this.props.variant;
        let className = "alert " + variant + " alert-dismissible";
        return (
            <div>
                {this.state.show != null &&
                    <div className={className} role="alert">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => this.hideAlert()}><span aria-hidden="true">&times;</span></button>
                    {this.state.show}
                </div>}
            </div>
        );
    }
}

export class Popup extends Component {

    render() {
        // If there's no content, don't bother creating a popup
        if (isNullOrEmpty(this.props.content)) {
            return (<span></span>);
        }

        const popup = (
            <Popover id={this.props.Id} title={this.props.title}>
                { this.props.content }
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement={this.props.placement} overlay={popup} rootClose={true}>
                <img className="cadeInput_HelpIcon" title="Click for help on answering" src={helpIcon} alt="Help" />
            </OverlayTrigger>
        );
    }
}



// WEBPACK FOOTER //
// ./src/helpers/BootstrapHelpers.js